import React from 'react';

import { useRouter } from 'nextjs-toploader/app';

import AnalyticsWrapper from '@/common/components/analytics-wrapper';
import Button from '@/common/components/button/button.component';
import Drawer from '@/common/components/drawer';
import Text from '@/common/components/text';
import { createQueryStringUtility } from '@/common/utils/create-query-string.utility';

import Avatar from '~/public/assets/images/svg/user-avatar.svg';

interface Props {
  openAuthDrawer: boolean;
  handleToggle: () => void;
}

export default function AuthDrawer({ openAuthDrawer, handleToggle }: Props) {
  const router = useRouter();

  const handleAuthRoute = () => {
    router.push(
      `/register${createQueryStringUtility({ redirect: '/profile/?from=cart' })}`
    );
  };

  return (
    <Drawer
      open={openAuthDrawer}
      placement="bottom"
      height={336}
      onClose={handleToggle}
      className="bg-re w-[520px] rounded-t-2xl"
      rootClassName="lg:hidden"
    >
      <div className="flex w-full flex-col items-center">
        <Avatar className="mt-4" />

        <Text className="mt-4 text-sm font-semibold text-black-400">
          شما وارد حساب کاربری خود نشده‌اید!
        </Text>

        <Text className="mt-3 text-xs  font-normal text-black-300">
          جهت ادامه فرآیند خرید ابتدا باید وارد حساب کاربری خود شوید.
        </Text>

        <div className="mt-8 flex w-full flex-col gap-y-3 ">
          <AnalyticsWrapper analytics={['checkout-click-login-v1']}>
            <Button
              id="checkout-click-login-v1"
              type="black"
              onClick={handleAuthRoute}
            >
              ورود / ثبت نام
            </Button>
          </AnalyticsWrapper>
          <Button type="tonal" onClick={handleToggle}>
            فعلا نه
          </Button>
        </div>
      </div>
    </Drawer>
  );
}
